import React, { useState, useEffect, useRef } from 'react'
import { Editor, IAllProps } from '@tinymce/tinymce-react'
import {
  Form,
  Input,
  Tag,
  ModalProps,
  FormProps,
  Modal,
  Space,
  Button,
  Row,
  Col,
  Select,
  Divider,
  useSelect,
  Descriptions,
  Typography,
  message,
  Icon,
  Icons,
} from '@pankod/refine-antd'

import { useCreateMany, useGetIdentity, useList, useMany, useTable } from '@pankod/refine-core'
import ReactMarkdown from 'react-markdown'
import ReactMde from 'react-mde'
// import ReactRichEditor from 'react-rich-text-editor'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'

import 'react-mde/lib/styles/css/react-mde-all.css'
import {
  IGrade,
  ISubject,
  ITopic,
  IBloomLevel,
  ITeacherLevel,
  IDifficultyLevel,
  IQuestion,
  IQuestionType,
  IWorkRequest,
  IReportTheme,
  ISubTheme,
  ITheme,
  IAspect,
  ICentaConcept,
  ITNTaxonomy,
  ICompetency,
  IStrand,
  IExplanationTypes,
  IWorkRequestGrades,
  IParentChildReference,
} from 'interfaces'
import { nhost } from 'utility'
import { createLogOpen, createUserHistory, getLastCreatedQuestion, updateWorkRequestStatus } from 'gql/mutations'
import { ReactMdeToolbarCommands } from 'helpers/markdownConfig'
import { useUserContext } from 'context/user'
import { useBloomsLevel, useCompetency, useDifficultyLevels, useGrades } from 'utility/masterData'
import RichTextEditor, { plugins, toolbar } from 'components/questions/rich_text_editor'
import RichTextRender from 'components/questions/rich_text_render'
import he from 'he'
import { elements } from 'chart.js'
import { getAllDistinctCustomTags, getDetailsById, getReportThemeDataByTopicId } from 'gql/query'
import SunTextEditor from 'components/questions/sun_text_editor'
import { generateAiQuestions } from '../../helpers/question/generateAiQuestions'
import aiIcon from '../../assets/spark_icon.png'
import { getUsersById } from 'users'
import ReferenceFileUpload from 'components/questions/reference_file_upload'
import { ReferenceDetailsPreview } from 'components/questions/referenceDetailsPreview'
import { checkQuestionIdsAreValid, updateMCQQuestionsOptionId } from 'helpers/question/questionOptionId'
import { LanguageSelect } from 'components/common/language_select'

const { FileSearchOutlined, SyncOutlined, CloudUploadOutlined, EditOutlined } = Icons

// import axios from 'axios'
const { TextArea } = Input
type CreateQuestionProps = {
  modalProps: ModalProps
  formProps: FormProps
  request?: any
  updatePercentage?: any
  customTags?: any
  handleFetchQuestions?: () => Promise<void>
}
type BlobInfo = {
  id: () => string
  name: () => string
  filename: () => string
  blob: () => Blob
  base64: () => string
  blobUri: () => string
  uri: () => string | undefined
}

type ProgressFn = (percent: number) => void

type UploadHandler = (blobInfo: BlobInfo, progress: ProgressFn) => Promise<string>
interface OptionTab {
  [key: string]: 'write' | 'preview'
}
export const CreateQuestion: React.FC<CreateQuestionProps> = ({
  modalProps,
  formProps,
  request,
  updatePercentage,
  customTags,
  handleFetchQuestions,
}) => {
  const editorRef = useRef<Editor>(null)
  const mcqEditorRef = useRef<Editor>(null)
  const editorMatch = useRef<Editor>(null)
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current)
    }
  }
  const { data: user } = useGetIdentity()
  const [editorContent, setEditorContent] = useState('')
  const { userRole } = useUserContext()
  const [selectedTab, setSelectedTab] = useState<'write' | 'preview'>('write')
  const [questionType, setQuestionType] = useState('MCQ')
  const [optionType, setOptionType] = useState('Text')
  const [selectedItems, setSelectedItems] = useState<any>(null)
  const [error, setError] = useState<boolean>(false)
  const { Option } = Select
  const [taxonomyfilter, setTaxonomyFilter] = useState<any[]>([])
  const [taxonomyRequired, setTaxonomyRequired] = useState(true)
  const [strandfilter, setStrandFilter] = useState<any[]>([])
  const [subjectFilter, setReportThemeFIlter] = useState<any[]>([])
  const [selectedOptionTab, setSelectedOptionTab] = useState<string[]>([])
  const { mutate: createGrades } = useCreateMany<IWorkRequestGrades>()
  const option_tags = ['Right Answer', 'Most Wrong', 'Close to Correct']
  const filteredOptions = option_tags?.filter(o => selectedItems !== o)
  const [themeQueryEnabled, seThemeQueryEnabled] = useState<boolean>(false)
  const [subThemeQueryEnabled, setSubThemeQueryEnabled] = useState<boolean>(false)
  const [TopicQueryEnabled, setTopicQueryEnabled] = useState<boolean>(false)
  const [reportThemeQueryEnabled, setReportThemeQueryEnabled] = useState<boolean>(false)
  const [mcqOptionFlagRule, setMcqOptionFlagRule] = useState<boolean>(true)
  const [selectedCustomTags, setSelectedCustomTag] = useState<any[]>([])
  const [isOpenCustomTag, setIsOpenCustomTag] = useState<boolean>(true)
  const [initialOptions, setInitialOptions] = useState([])
  const [initialTitleDetails, setInitialTitleDetails] = useState({ title: '', insights: '' })
  const [loading, setLoading] = useState<boolean>(false)
  const [instructionsDetails, setInstructionDetails] = useState('')
  const [referenceTextDetails, setReferenceTextDetails] = useState('')
  const [userAiPermission, setUserAiPermission] = useState<boolean>(false)
  const [textReference, setTextReference] = useState<boolean>(true)
  // const referenceRef: any = useRef()

  // const showCorrectAnswerError=
  {
    /*Variant Selection ****************/
  }
  {
    // console.log({ modalProps })
  }
  const [variantListIds, setVariantListIds] = useState<string[]>([])
  const [variantList, setVariantList] = useState<object[]>([])

  const initialValues = async () => {
    // formProps?.form?.get

    return await formProps?.form?.setFieldsValue({
      report_theme_id: request?.report_theme_id,
      theme_id: request?.theme_id,
      sub_theme_id: request?.sub_theme_id,
      topic_id: request?.topic_id,
      competency_id: request?.competency_id,
      taxonomy_id: request?.taxonomy_id,
      strand_id: request?.strand_id,
    })
  }
  const findUserAiPermission = async () => {
    try {
      const userDetails: any = await getUsersById(user.id)
      const newUser = userDetails?.users[0]
      if (newUser) {
        setUserAiPermission(newUser.ai_permission)
      } else {
        setUserAiPermission(false)
      }
    } catch (err) {
      console.log(err)
      setUserAiPermission(false)
    }
  }
  useEffect(() => {
    if (request?.request_type === 'V') {
      let arr: string[] = []
      request?.variant_options?.length > 0 &&
        request?.variant_options?.map((item: any) => {
          arr.push(item?.question_id)
        })
      setVariantListIds(arr)
    }

    initialValues()
    findUserAiPermission()
  }, [request])

  const { data: questionQueryResult, isLoading } = useMany<IQuestion>({
    resource: 'questions',
    queryOptions: { enabled: modalProps?.visible },
    ids: variantListIds,
    metaData: {
      fields: ['id', 'title', 'question_id'],
    },
  })

  useEffect(() => {
    let arr: object[] = []
    questionQueryResult?.data?.forEach(element => {
      request?.variant_options?.forEach((variant: any) => {
        if (variant?.question_id === element?.id) {
          arr.push({
            title: element?.title,
            question_id: element?.question_id,
            id: element?.id,
            count: variant?.variant_count,
          })
        }
      })
    })
    setVariantList(arr)
  }, [questionQueryResult])

  {
    /*Variant Selection ****************/
  }

  //file upload start ------------------------------
  const [fileList, setFileList] = useState<any>({})
  const [uploading, setUploading] = useState(false)

  // const handleImageUpload = async (option_details: any) => {
  //   setUploading(true)
  //   let metadatas: any = {}
  //   for (let key = 0; key < option_details.length; key++) {
  //     const file = option_details[key]?.option_image_id.file
  //     const { fileMetadata } = await nhost.storage.upload({ file })

  //     metadatas[key] = fileMetadata
  //   }
  //   setUploading(false)
  //   return metadatas
  // }
  const handleUploadDescriptionImage = () => {}
  //file upload end ---------------------------

  const handleFilePickerCallback = function (callback: any, value: any, meta: any) {
    console.log('------call--------', callback)
    console.log('------value--------', value)

    console.log('------meta--------', meta)
    callback('mypage.html', { text: 'My text' })
    // var input = document.createElement('input')
    // input.setAttribute('type', 'file')
    // input.setAttribute('accept', 'image/*')

    // input.onchange = async function ({}) {
    //   var file = this.files[0]
    //   console.log({ file })
    //   const { fileMetadata: returnFileData } = await nhost.storage.upload({
    //     file,
    //   })
    //   console.log({ returnFileData })
    //   const imageUrl = await nhost.storage.getPublicUrl({
    //     fileId: returnFileData?.id!,
    //   })
    //   callback(imageUrl, { alt: 'Uploaded Image' })
    // }

    // input.click()
  }

  const gradeSelectProps = useGrades(modalProps?.visible)
  const bloomlevelSelectProps = useBloomsLevel(modalProps?.visible)
  const difficultylevelSelectProps = useDifficultyLevels(modalProps?.visible)
  const competencySelectProps = useCompetency(modalProps?.visible)

  const { tableQueryResult: parentChildQuestionReferenceTexts } = useTable<IParentChildReference>({
    queryOptions: { enabled: modalProps?.visible && request && request?.request_type === 'PC' },
    resource: 'parent_child_question_reference_data',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'reference_data'] },
    permanentFilter: request?.id ? [{ field: 'work_request_id', operator: 'eq', value: request?.id }] : [],
  })

  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    queryOptions: { enabled: themeQueryEnabled && modalProps?.visible },
    resource: 'themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id', 'report_theme_id'] },
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialFilter: [
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: request?.report_theme_id,
      },
    ],
  })
  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    queryOptions: { enabled: subThemeQueryEnabled && modalProps?.visible },
    metaData: { fields: ['id', 'name', 'theme_id'] },
    initialPageSize: 10000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialFilter: [
      {
        field: 'theme_id',
        operator: 'eq',
        value: request?.theme_id,
      },
    ],
  })

  const {
    filters: topicFilters,
    setFilters: setTopicFilters,
    tableQueryResult: topicResult,
    sorter,
  } = useTable<ITopic>({
    resource: 'topics',
    queryOptions: { enabled: TopicQueryEnabled && modalProps?.visible },
    initialPageSize: 10000,
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialFilter: [
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: request?.sub_theme_id ?? '5d8c5987-c185-4bd6-a5c1-2dae0a69501d',
      },
    ],
  })

  const { selectProps: tntaxonomySelectProps, queryResult: tnTaxonomyResults } = useSelect<ITNTaxonomy>({
    queryOptions: { staleTime: Infinity, enabled: modalProps?.visible },
    resource: 'tn_taxonomys',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      ...(taxonomyfilter ?? []),
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: strandSelectProps, queryResult: strandResults } = useSelect<IStrand>({
    queryOptions: { staleTime: Infinity, enabled: modalProps?.visible },
    resource: 'strands',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'teacher_level_id', 'taxonomy_id', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      ...(strandfilter ?? []),
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    queryOptions: { enabled: modalProps?.visible },
    resource: 'question_types',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: reportThemeProps } = useSelect<IReportTheme>({
    queryOptions: { staleTime: Infinity, enabled: modalProps?.visible && reportThemeQueryEnabled },

    resource: 'report_themes',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    filters: subjectFilter,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
  })

  // const handleReportThemeChange = (value: { value: any }) => {
  //   themeFilters.pop()
  //   formProps?.form?.setFieldsValue({
  //     sub_theme_id: null,
  //     topic_id: null,
  //     theme_id: null,
  //   })
  //   setThemeFilters([
  //     {
  //       field: 'report_theme_id',
  //       operator: 'eq',
  //       value: value,
  //     },
  //   ])
  // }

  const handleThemeChange = (value: { value: any }) => {
    subThemeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
    })
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleSubThemeChange = (value: { value: any }) => {
    topicFilters.pop()
    formProps?.form?.setFieldsValue({
      topic_id: null,
    })
    setTopicFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }

  const handleCompetencyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      tn_taxonomy_id: null,
      teacher_level_id: null,
      strand_id: null,
    })
    let data: any = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: value,
      },
    ]
    setTaxonomyFilter(data)
    // setStrandFilter(data)
  }
  const handleTaxonomyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      teacher_level_id: null,
      strand_id: null,
    })
    // let arr: any[] = [...strandfilter]
    // let arr: any[] = [...strandfilter.filter(item => item?.field === 'competency_id')]
    // let data: any = {
    //   field: 'taxonomy_id',
    //   operator: 'eq',
    //   value: value,
    // }
    // arr.push(data)
    // setStrandFilter(arr)
    // console.log(formProps?.form?.getFieldValue('competency_id'),'Competency Id')
    // const updatedFilters = strandfilter.filter(filter => filter.field !== 'taxonomy_id')
    // updatedFilters.push({
    //   field: 'taxonomy_id',
    //   operator: 'eq',
    //   value: value,
    // })
    const updateFilter = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: formProps?.form?.getFieldValue('competency_id'),
      },
      {
        field: 'taxonomy_id',
        operator: 'eq',
        value: value,
      },
    ]
    setStrandFilter(updateFilter)
  }

  const handleTeacherLevelChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      strand_id: null,
    })
    let arr: any[] = [...strandfilter]
    let data: any = {
      field: 'teacher_level_id',
      operator: 'eq',
      value: value,
    }

    arr.push(data)

    setStrandFilter(arr)
  }

  const handleQuestionType = (value: any) => {
    setInitialOptions([])
    setInitialTitleDetails({ title: '', insights: '' })
    formProps?.form?.setFieldsValue({ title: '' })
    formProps?.form?.setFieldsValue({ question_insight: '' })
    formProps?.form?.setFieldsValue({ option_details: [] })
    if (questionType !== value) {
      setInstructionDetails('')
    }
    setQuestionType(value)
  }
  const handleOptionType = (value: any) => {
    setOptionType(value)
  }

  const handleChangeCustomTag = async (values: any) => {
    if (values.length > 1) {
      setSelectedCustomTag(values[0])
      setIsOpenCustomTag(false)
    } else {
      setIsOpenCustomTag(true)
    }
  }

  const onFinish = async (values: any) => {
    const validIds = await checkQuestionIdsAreValid(values?.variant_of, values?.transilation_of)
    values.variant_of = values?.variant_of ? Number(values.variant_of) : null
    values.transilation_of = values?.transilation_of ? Number(values.transilation_of) : null
    //at least one option insight is required
    const atleastOneOptionInsightIspresent =
      values?.question_type_id !== 'MCQ'
        ? true
        : values?.option_details?.some(
            (opt: any) =>
              opt.option_flag === "Right Answer" &&
              opt?.option_insight
                ?.replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/g, ' ')
                .trim().length > 0
          ) ?? false

    if (
      validIds &&
      values.title &&
      isOpenCustomTag &&
      (values?.question_type_id !== 'MCQ' || values?.option_details.length === 4) &&
      atleastOneOptionInsightIspresent
    ) {
      const DecodedQuestionTitle = he.decode(values.title)
      values.title = DecodedQuestionTitle
      values.custom_tag = Array.isArray(values.custom_tag) && values.custom_tag.length > 0 ? values.custom_tag[0] : null
      let is_ra_found = false
      const questionTitle = editorRef?.current?.editor?.getContent()
      //image option transform
      let option_array: any = []
      let optionTextsAreUnique = true

      if (questionType === 'MCQ' && values?.option_details?.length > 0) {
        const uniqueOptionTexts = new Set()
        values.option_details.forEach((option: any, index: number) => {
          option.option_text = he.decode(option.option_text)
          if (uniqueOptionTexts.has(option.option_text)) {
            optionTextsAreUnique = false
            return
          } else {
            uniqueOptionTexts.add(option.option_text)
            option.option_flag = option?.option_flag ? option?.option_flag : ''
            if (option.option_insight) option.option_insight = he.decode(option.option_insight)
            let newOption = { ...option }
            if (option?.option_text.includes('![image]')) {
              const middle = option?.option_text?.slice(option?.option_text.lastIndexOf('/') + 1, option?.option_text?.length - 1)
              newOption.option_image_id = middle
              newOption.type = 'Image'
              // newOption.option_image_name = ''
            } else if (option?.option_text?.includes('<img')) {
              let imgTagPattern = /<img.*?>/
              let imgTagMatch = option?.option_text?.match(imgTagPattern)
              let imgTagString = imgTagMatch ? imgTagMatch[0] : ''
              let imgSrc = imgTagString.split('"')?.[1] ?? ''
              let imgId = imgSrc?.slice(imgSrc?.lastIndexOf('/') + 1)
              newOption['option_image_id'] = imgId
              newOption['type'] = 'Image'
            } else {
              newOption['type'] = 'Text'
            }
            const option_uuid = String.fromCharCode(97 + index)
            newOption['option_uuid'] = option_uuid
            option_array.push(newOption)
            // console.log('first', option?.option_flag, option?.option_flag === 'Right Answer')
            if (is_ra_found) {
              return
            }
            if (option?.option_flag === 'Right Answer') {
              is_ra_found = true
              return
            } else {
              is_ra_found = false
            }
          }
        })
      } else if (questionType === 'Match' && values?.option_details?.length > 0) {
        option_array = []
        const uniqueOptionTexts = new Set()
        values.option_details.forEach((option: any, index: number) => {
          let newOption = { ...option }
          if (uniqueOptionTexts.has(option.left_label_text) || uniqueOptionTexts.has(option.right_label_text)) {
            optionTextsAreUnique = false
          } else {
            uniqueOptionTexts.add(option.left_label_text)
            uniqueOptionTexts.add(option.right_label_text)
          }
          //LEFT LABEL IMAGE ID
          if (option?.left_label_text.includes('![image]')) {
            let left_middle = option?.left_label_text?.slice(option?.left_label_text.lastIndexOf('/') + 1, option?.left_label_text?.length - 1)
            newOption.left_label_image = left_middle
            newOption.type = 'Image'
          } else if (option?.left_label_text?.includes('<img')) {
            let imgTagPattern = /<img.*?>/
            let imgTagMatch = option?.left_label_text?.match(imgTagPattern)
            let imgTagString = imgTagMatch ? imgTagMatch[0] : ''
            let imgSrc = imgTagString.split('"')?.[1] ?? ''
            let imgId = imgSrc?.slice(imgSrc?.lastIndexOf('/') + 1)
            newOption['left_label_image'] = imgId
            newOption['type'] = 'Image'
          } else {
            newOption['type'] = 'Text'
            newOption['left_label_image'] = null
          }

          //RIGHT LABEL IMAGE ID
          if (option?.right_label_text.includes('![image]')) {
            let right_middle = option?.right_label_text?.slice(option?.right_label_text.lastIndexOf('/') + 1, option?.right_label_text?.length - 1)
            newOption.right_label_image = right_middle
            newOption.type = 'Image'
          } else if (option?.right_label_text?.includes('<img')) {
            let imgTagPattern = /<img.*?>/
            let imgTagMatch = option?.right_label_text?.match(imgTagPattern)
            let imgTagString = imgTagMatch ? imgTagMatch[0] : ''
            let imgSrc = imgTagString.split('"')?.[1] ?? ''
            let imgId = imgSrc?.slice(imgSrc?.lastIndexOf('/') + 1)
            newOption['right_label_image'] = imgId
            newOption['type'] = 'Image'
          } else {
            newOption['right_label_image'] = null
          }
          // } else {
          //   newOption.type = 'Text'
          // }
          option_array.push(newOption)
        })
      } else if (questionType === 'Fill' && values?.option_details?.length > 0) {
        const uniqueOptionTexts = new Set()
        values?.option_details.forEach((option: any) => {
          option.right_answer = he.decode(option.right_answer)
          if (uniqueOptionTexts.has(option.right_answer)) {
            optionTextsAreUnique = false
            return
          } else {
            uniqueOptionTexts.add(option.right_answer)
          }
        })
      }

      // console.log({ option_array })

      // console.log({ values })

      // work request status change
      if (request?.id !== undefined && request?.status === 'Open' && modalProps?.visible) {
        updateWorkRequestStatus(request?.id, 'In Progress')
      }
      //finding report theme with topic
      let reportThemeId = request?.report_theme_id ? request?.report_theme_id : ''
      if (!reportThemeId) {
        const getReportThemeIdResponse: any = await getReportThemeDataByTopicId(request?.topic_id || values?.topic_id)
        if (getReportThemeIdResponse && getReportThemeIdResponse.report_themes.length) {
          console.log(getReportThemeIdResponse.report_themes[0].id, 'report theme response Id')
          reportThemeId = getReportThemeIdResponse.report_themes[0].id
        }
      }

      if (!uploading) {
        if (optionTextsAreUnique) {
          // console.log(optionTextsAreUnique, 'is it unique', is_ra_found, 'right answer')
          if (questionType === 'MCQ') {
            if (option_array.length > 0) {
              if (selectedItems !== '') {
                return (
                  formProps.onFinish &&
                  formProps.onFinish({
                    ...values,
                    status: 'Open',
                    option_type: '',
                    option_details: option_array,
                    work_request_id: request?.id,
                    question_type_id: values?.question_type_id,
                    creator_id: request?.creator_id,
                    subject_id: request?.subject_id,
                    bloom_level_id: request?.bloom_level_id ?? values?.bloom_level_id,
                    centa_standard_id: request?.centa_standard_id ?? values?.centa_standard_id,
                    difficulty_level_id: request?.difficulty_level_id ?? values?.difficulty_level_id,
                    grade_ids: request?.grade_ids?.length > 0 ? request?.grade_ids : values?.grade_ids,
                    theme_id: request?.theme_id ?? values?.theme_id,
                    sub_theme_id: request?.sub_theme_id ?? values?.sub_theme_id,
                    topic_id: request?.topic_id ?? values?.topic_id,
                    report_theme_id: reportThemeId || null,
                    // report_theme_id: request?.report_theme_id ?? values?.report_theme_id,
                    strand_id: request?.strand_id ?? values?.strand_id,
                    teacher_level_id: request?.teacher_level_id ?? values?.teacher_level_id,
                    competency_id: request?.competency_id ?? values?.competency_id,
                    centa_concept_id: request?.centa_concept_id ?? values?.centa_concept_id,
                    tn_taxonomy_id: request?.taxonomy_id ?? values?.tn_taxonomy_id,
                  })
                )
              }
            } else {
              return (
                formProps.onFinish &&
                formProps.onFinish({
                  ...values,
                  status: 'Open',
                  option_type: '',
                  option_details: values?.option_details,
                  work_request_id: request?.id,
                  question_type_id: values?.question_type_id,
                  creator_id: request?.creator_id,
                  subject_id: request?.subject_id,
                  bloom_level_id: request?.bloom_level_id ?? values?.bloom_level_id,
                  centa_standard_id: request?.centa_standard_id ?? values?.centa_standard_id,
                  difficulty_level_id: request?.difficulty_level_id ?? values?.difficulty_level_id,
                  grade_ids: request?.grade_ids?.length > 0 ? request?.grade_ids : values?.grade_ids,
                  theme_id: request?.theme_id ?? values?.theme_id,
                  sub_theme_id: request?.sub_theme_id ?? values?.sub_theme_id,
                  topic_id: request?.topic_id ?? values?.topic_id,
                  report_theme_id: reportThemeId || null,
                  // report_theme_id: request?.report_theme_id ?? values?.report_theme_id,
                  strand_id: request?.strand_id ?? values?.strand_id,
                  teacher_level_id: request?.teacher_level_id ?? values?.teacher_level_id,
                  competency_id: request?.competency_id ?? values?.competency_id,
                  centa_concept_id: request?.centa_concept_id ?? values?.centa_concept_id,
                  tn_taxonomy_id: request?.taxonomy_id ?? values?.tn_taxonomy_id,
                })
              )
            }
          } else if (questionType === 'Match') {
            return (
              formProps.onFinish &&
              formProps.onFinish({
                ...values,
                status: 'Open',
                option_type: '',
                option_details: option_array,
                work_request_id: request?.id,
                question_type_id: values?.question_type_id,
                creator_id: request?.creator_id,
                subject_id: request?.subject_id,
                bloom_level_id: request?.bloom_level_id ?? values?.bloom_level_id,
                centa_standard_id: request?.centa_standard_id ?? values?.centa_standard_id,
                difficulty_level_id: request?.difficulty_level_id ?? values?.difficulty_level_id,
                grade_ids: request?.grade_ids?.length > 0 ? request?.grade_ids : values?.grade_ids,
                theme_id: request?.theme_id ?? values?.theme_id,
                sub_theme_id: request?.sub_theme_id ?? values?.sub_theme_id,
                topic_id: request?.topic_id ?? values?.topic_id,
                report_theme_id: reportThemeId || null,
                // report_theme_id: request?.report_theme_id ?? values?.report_theme_id,
                strand_id: request?.strand_id ?? values?.strand_id,
                teacher_level_id: request?.teacher_level_id ?? values?.teacher_level_id,
                competency_id: request?.competency_id ?? values?.competency_id,
                centa_concept_id: request?.centa_concept_id ?? values?.centa_concept_id,
                tn_taxonomy_id: request?.taxonomy_id ?? values?.tn_taxonomy_id,
              })
            )
          } else {
            return (
              formProps.onFinish &&
              formProps.onFinish({
                ...values,
                status: 'Open',
                option_type: '',
                option_details: values?.option_details,
                work_request_id: request?.id,
                question_type_id: values?.question_type_id,
                creator_id: request?.creator_id,
                subject_id: request?.subject_id,
                bloom_level_id: request?.bloom_level_id ?? values?.bloom_level_id,
                centa_standard_id: request?.centa_standard_id ?? values?.centa_standard_id,
                difficulty_level_id: request?.difficulty_level_id ?? values?.difficulty_level_id,
                grade_ids: request?.grade_ids?.length > 0 ? request?.grade_ids : values?.grade_ids,
                theme_id: request?.theme_id ?? values?.theme_id,
                sub_theme_id: request?.sub_theme_id ?? values?.sub_theme_id,
                topic_id: request?.topic_id ?? values?.topic_id,
                report_theme_id: reportThemeId || null,
                // report_theme_id: request?.report_theme_id ?? values?.report_theme_id,
                strand_id: request?.strand_id ?? values?.strand_id,
                teacher_level_id: request?.teacher_level_id ?? values?.teacher_level_id,
                competency_id: request?.competency_id ?? values?.competency_id,
                centa_concept_id: request?.centa_concept_id ?? values?.centa_concept_id,
                tn_taxonomy_id: request?.taxonomy_id ?? values?.tn_taxonomy_id,
              })
            )
          }
        } else {
          // console.log(optionTextsAreUnique, 'is not unique')
          message.warning("can't upload the question now!. options are duplicated")
        }
      }
    } else {
      message.error(
        values?.question_type_id === 'MCQ' && values?.option_details?.length !== 4
          ? "Can't save question. Options must be 4"
          : values?.variant_of || values?.transilation_of
          ? 'Unable to save the question. Please check if the mentioned question IDs are valid'
          : !atleastOneOptionInsightIspresent
          ? 'Right Answer insight is mandatory. Please add an insight before saving the question'
          : "Can't save the question, Multiple custom tags can't be selected"
      )
    }
  }

  useEffect(() => {
    if (request && request.question_type_id) {
      setQuestionType(request.question_type_id)
    }
  }, [request])
  useEffect(() => {
    if (userRole === 'qcreator' || userRole === 'variantcreator') {
      setTaxonomyRequired(false)
    }
  }, [userRole])

  useEffect(() => {
    themeFilters.pop()
    if (request?.id) {
      let data: any = [
        {
          field: 'subject_id',
          operator: 'eq',
          value: request?.subject_id,
        },
      ]
      setReportThemeFIlter(data)
      setThemeFilters([
        {
          field: 'subject_id',
          operator: 'eq',
          value: request?.subject_id ?? '5d8c5987-c185-4bd6-a5c1-2dae0a69501d',
        },
      ])
      setSubThemeFilters([
        {
          field: 'theme_id',
          operator: 'eq',
          value: request?.theme_id ?? '99172a7a-b2b1-4467-9239-7de8710f6467',
        },
      ])
      setTopicFilters([
        {
          field: 'sub_theme_id',
          operator: 'eq',
          value: request?.sub_theme_id ?? '5d8c5987-c185-4bd6-a5c1-2dae0a69501d',
        },
      ])
      setTaxonomyFilter([
        {
          field: 'competency_id',
          operator: 'eq',
          value: request?.competency_id ?? '5d8c5987-c185-4bd6-a5c1-2dae0a69501d',
        },
      ])

      let strandfilter = []
      if (request?.taxonomy_id) {
        strandfilter.push({
          field: 'taxonomy_id',
          operator: 'eq',
          value: request?.taxonomy_id,
        })
      }
      if (request?.competency_id) {
        strandfilter.push({
          field: 'competency_id',
          operator: 'eq',
          value: request?.competency_id,
        })
      }
      if (request?.teacher_level_id) {
        strandfilter.push({
          field: 'teacher_level_id',
          operator: 'eq',
          value: request?.teacher_level_id,
        })
        setStrandFilter(strandfilter)
      }
      setReportThemeQueryEnabled(true)
      seThemeQueryEnabled(true)
      setSubThemeQueryEnabled(true)
      setTopicQueryEnabled(true)
    }
  }, [request])
  const gradeList = useList<IGrade>({
    resource: 'grades',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      pagination: { pageSize: 1000 },
    },
  })
  const renderGrades = (item: any) => {
    let text: object[] = []
    for (let i = 0; i < item?.length; i++) {
      let result = gradeList?.data?.data?.filter((grade: any) => item[i] === grade?.id)[0]
      if (result !== undefined) {
        text.push(<Tag>{result?.name}</Tag>)
      }
    }
    return text
  }
  {
    console.log('errorrrrrrr', error)
  }
  const handleValueChange = (value: any, key: any) => {
    // console.log({ value, key })
  }

  const save = async function* (data: any) {
    const wait = function (time: any) {
      return new Promise<void>((a, r) => {
        setTimeout(() => a(), time)
      })
    }
    var arrayBufferView = new Uint8Array(data)
    var blob = new Blob([arrayBufferView], { type: 'image/jpeg' })
    var file = new File([blob], 'image.jpg')

    const { fileMetadata } = await nhost.storage.upload({ file })
    const publicUrl = nhost.storage.getPublicUrl({ fileId: fileMetadata?.id || '' })

    await wait(2000)
    // yields the URL that should be inserted in the markdown

    yield publicUrl
    await wait(2000)
    return true
  }

  const handleImageUplodFromEditor: UploadHandler = async (blobInfo, progress) => {
    let url = ''
    try {
      const fileName = blobInfo?.filename()
      const blob = blobInfo?.blob()
      const file = new File([blob], fileName)
      const { fileMetadata } = await nhost.storage.upload({ file })
      const fileId = fileMetadata?.id ?? ''
      url = await nhost.storage.getPublicUrl({ fileId })
    } catch (err) {
      console.log({ err })
    }
    return Promise.resolve(url)
  }

  const handleSetFormList = (content: string, key: number, fieldName: string, index: any) => {
    const optionsArr = formProps?.form?.getFieldValue('option_details')
    if (optionsArr?.[index] === undefined) {
      optionsArr[index] = { [fieldName]: content }
    }

    const formVal = optionsArr?.[index]
    Object.assign(formVal, { ...formVal, [fieldName]: content })
    formProps?.form?.setFieldsValue({ option_details: optionsArr })
  }

  const saveOptions = async function* (data: any) {
    // console.log('first-----', key)
    const wait = function (time: any) {
      return new Promise<void>((a, r) => {
        setTimeout(() => a(), time)
      })
    }
    var arrayBufferView = new Uint8Array(data)
    var blob = new Blob([arrayBufferView], { type: 'image/jpeg' })
    var file = new File([blob], 'image.jpg')
    const { fileMetadata } = await nhost.storage.upload({ file })
    // console.log({ fileMetadata })
    let url = nhost.storage.getPublicUrl({ fileId: fileMetadata?.id || '' })

    await wait(2000)
    // yields the URL that should be inserted in the markdown

    yield url
    await wait(2000)
    return true
  }
  // const handleOptionTags = (value: string) => {
  const handleOptionTags = (value: string) => {
    if (questionType === 'MCQ') {
      const field = formProps?.form?.getFieldValue('option_details')
      const found = field?.findIndex((element: any) => element?.option_flag === 'Right Answer')
      const foundCC = field?.findIndex((element: any) => element?.option_flag === 'Close to Correct')
      const foundMW = field?.findIndex((element: any) => element?.option_flag === 'Most Wrong')
      setSelectedItems(found === -1 ? '' : 'Right Answer')
      setMcqOptionFlagRule(foundCC === -1 && foundMW === -1 ? true : false)

      // if (found === -1) {
      //   setSelectedItems('')
      // } else {
      //   setSelectedItems('Right Answer')
      // }
    }
  }
  const handleOptionTabChange = (value: any, key: any) => {
    let arr: string[] = [...selectedOptionTab]
    if (value === 'preview') {
      arr.push(key)
    }
    if (value === 'write') {
      if (arr.includes(key)) {
        arr.splice(arr.indexOf(key), 1)
      }
    }
    // console.log({ arr })
    setSelectedOptionTab(arr)
  }

  const imageUpload = async (blobInfo: any): Promise<string> => {
    alert(1)
    try {
      // Replace the URL with your actual image upload endpoint
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/upload-img`, {
        // const response = await fetch('http://localhost:3001/upload-img', {
        method: 'POST',
        body: JSON.stringify(blobInfo),
        headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
      })

      if (response.ok) {
        const data = await response.json()
        // Replace 'imageUrl' with the key that holds the image URL in the response
        return data.imageUrl // Return the image URL on success
      } else {
        throw new Error('Image upload failed')
      }
    } catch (error) {
      throw new Error('Image upload failed')
    }
  }

  const handleEditorTitle = (titleText: string, titleInsights: string) => {
    setInitialTitleDetails({ title: titleText ? titleText : '', insights: titleInsights ? titleInsights : '' })
    formProps?.form?.setFieldsValue({ title: titleText ?? '' })
    formProps?.form?.setFieldsValue({ question_insight: titleInsights ?? '' })
  }

  return (
    <Modal {...modalProps} title="Create Question" style={{ height: '100%', top: 0 }}>
      {JSON.stringify(request) !== '{}' && request?.id !== '' ? (
        <>
          <Descriptions size="small" column={1}>
            {/* <Descriptions.Item label="">{<Tag color="blue">{request?.status}</Tag>}</Descriptions.Item> */}
            <Descriptions.Item label="Work Request">{request?.name}</Descriptions.Item>
          </Descriptions>
          <Descriptions size="small" column={3}>
            {request?.request_type && (
              <Descriptions.Item label="Request Type">{`${
                request?.request_type === 'Q' ? 'Normal' : request?.request_type === 'PC' ? 'Parent Child Question' : 'Variant'
              }`}</Descriptions.Item>
            )}
            {request?.workRequestGrades?.length > 0 && (
              <Descriptions.Item label="Grade">
                {request?.workRequestGrades?.map((item: any) => (
                  <Tag key={item?.grade_id}>{item?.grade?.name}</Tag>
                ))}
              </Descriptions.Item>
            )}
            {/* <Descriptions.Item label="Grade">
              {record?.workRequestGrades?.length > 0 &&
                record?.workRequestGrades?.map((item: any) => <Tag key={item?.grade_id}>{item?.grade?.name}</Tag>)}
            </Descriptions.Item> */}
            {/* {request?.grade_ids?.length > 0 && <Descriptions.Item label="Grade">{renderGrades(request?.grade_ids)}</Descriptions.Item>} */}
            {request?.subject?.name && <Descriptions.Item label="Subject">{request?.subject?.name}</Descriptions.Item>}
            {request?.report_theme?.name && <Descriptions.Item label="Report Theme">{request?.report_theme?.name}</Descriptions.Item>}
            {request?.theme?.name && <Descriptions.Item label="Theme">{request?.theme?.name}</Descriptions.Item>}
            {request?.sub_theme?.name && <Descriptions.Item label="Sub Theme">{request?.sub_theme?.name}</Descriptions.Item>}
            {request?.topic?.name && <Descriptions.Item label="Topic">{request?.topic?.name}</Descriptions.Item>}
            {request?.question_type?.name && <Descriptions.Item label="Question Type">{request?.question_type?.name}</Descriptions.Item>}
          </Descriptions>
          <Divider style={{ margin: '4px 0' }} />
          <b>Tags:</b>
          <Descriptions size="small" column={2}>
            {request?.competencies?.name && <Descriptions.Item label="Competency">{request?.competencies?.name}</Descriptions.Item>}
            {request?.taxonomy?.name && <Descriptions.Item label="Taxonomy">{request?.taxonomy?.name}</Descriptions.Item>}
            {request?.teacher_level?.name && <Descriptions.Item label="Teacher Level">{request?.teacher_level?.name}</Descriptions.Item>}
            {request?.strands?.name && <Descriptions.Item label="Standard">{request?.strands?.name}</Descriptions.Item>}
            {request?.bloom_level?.name && <Descriptions.Item label="Bloom Level">{request?.bloom_level?.name}</Descriptions.Item>}
            {request?.difficulty_level?.name && <Descriptions.Item label="Difficulty">{request?.difficulty_level?.name}</Descriptions.Item>}

            {request?.centa_concept?.name && <Descriptions.Item label="Centa Concept">{request?.centa_concept?.name}</Descriptions.Item>}
          </Descriptions>
        </>
      ) : null}
      <Row gutter={[16, 0]}>
        <Col xs={24} lg={24}>
          <Divider orientation="left" orientationMargin="0" className="primary">
            Question Details
          </Divider>
        </Col>
      </Row>
      <Form
        {...formProps}
        initialValues={{
          report_theme_id: request?.report_theme_id,
          theme_id: request?.theme_id,
          sub_theme_id: request?.sub_theme_id,
          topic_id: request?.topic_id,
          competency_id: request?.competency_id,
          taxonomy_id: request?.taxonomy_id,
          strand_id: request?.strand_id,
        }}
        layout="vertical"
        onFinish={async values => {
          const res: any = await onFinish(values)
          //const option_id with question_id
          if (res?.data && res?.data?.question_type_id === 'MCQ') {
            const uploadedOptions = res?.data?.option_details || []
            const question_id = res?.data?.question_id
            const updateOptionId = await updateMCQQuestionsOptionId(uploadedOptions, question_id, res?.data?.id)
            if (updateOptionId) {
              console.log('options ids are updated with question id')
            }
          }

          if (res?.data?.id) {
            if (updatePercentage) {
              await updatePercentage()
            }
            const resp: any = await getLastCreatedQuestion()
            if (handleFetchQuestions) {
              await handleFetchQuestions()
            }
            const question = resp?.questions[0]
            const createlogOpen = await createLogOpen(question?.creator_id, request, question?.id)
            let grade_array: object[] = []
            if (values?.grade_ids?.length > 0 || request?.grade_ids?.length > 0) {
              if (values?.grade_ids?.length > 0) {
                values?.grade_ids?.map((item: any) => {
                  grade_array.push({
                    grade_id: item,
                    question_id: question?.id,
                  })
                })
              } else if (request?.grade_ids?.length > 0) {
                request?.grade_ids?.map((item: any) => {
                  grade_array.push({
                    grade_id: item,
                    question_id: question?.id,
                  })
                })
              }

              const gradeAdded = await createGrades({
                resource: 'question_grades',
                values: grade_array,
              })
            }

            setSelectedItems('')

            // setError(error)
            createUserHistory('questions', 'create', question?.id, user?.id, userRole)
          } else {
            console.log('duplicated options')
          }
          if (res?.data?.id) {
            formProps?.form?.resetFields()
          }
        }}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item label="Question Type" name="question_type_id" rules={[{ required: true }]}>
              <Select onChange={handleQuestionType} {...questionTypeSelectProps} placeholder="Select Question Type" />
            </Form.Item>
          </Col>

          {JSON.stringify(request) !== '{}' && request?.request_type === 'PC' && (
            <Col xs={24} lg={8}>
              <Form.Item label="Reference Texts" name="reference_data_id" rules={[{ required: true }]}>
                <Select onChange={value => console.log(value, 'Value')} allowClear showSearch>
                  {parentChildQuestionReferenceTexts?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      <RichTextRender content={item?.reference_data} key={item?.id} styles={{ width: 'max', height: '50px' }} />
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}

          {JSON.stringify(request) === '{}' || request?.grade_ids?.length <= 0 || request?.grade_ids === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Grade" name="grade_ids" rules={[{ required: true }]}>
                <Select {...gradeSelectProps} mode="multiple" showSearch={false} />
              </Form.Item>
            </Col>
          ) : null}
          {/* ----- Report theme filter */}
          {/* {JSON.stringify(request) === '{}' || request?.report_theme_id === '' || request?.report_theme_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item
                initialValue={request?.report_theme_id}
                label="Report Theme (TN_Term_Month)"
                name="report_theme_id"
                rules={[{ required: true }]}
              >
                <Select {...reportThemeProps} showSearch onChange={handleReportThemeChange} allowClear />
              </Form.Item>
            </Col>
          ) : null} */}

          {JSON.stringify(request) === '{}' || request?.theme_id === '' || request?.theme_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Theme" name="theme_id" rules={[{ required: true }]}>
                <Select
                  onChange={handleThemeChange}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // disabled={
                  //   formProps?.form?.getFieldValue('report_theme_id') == null || formProps?.form?.getFieldValue('report_theme_id') == undefined
                  //     ? true
                  //     : false
                  // }
                >
                  {themeResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(request) === '{}' || request?.sub_theme_id === '' || request?.sub_theme_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Sub-theme" name="sub_theme_id" rules={[{ required: true }]}>
                <Select
                  onChange={handleSubThemeChange}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  disabled={
                    formProps?.form?.getFieldValue('theme_id') == null || formProps?.form?.getFieldValue('theme_id') == undefined ? true : false
                  }
                  // disabled={formProps?.form?.getFieldValue('theme_id') === null ? true : false}
                >
                  {subThemeResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(request) === '{}' || request?.topic_id === '' || request?.topic_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Topic" name="topic_id" rules={[{ required: true, message: 'Please select topic before creating question' }]}>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  disabled={
                    formProps?.form?.getFieldValue('sub_theme_id') == null || formProps?.form?.getFieldValue('sub_theme_id') == undefined
                      ? true
                      : false
                  }
                >
                  {topicResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(request) === '{}' || request?.bloom_level_id === '' || request?.bloom_level_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the appropriate Bloom's taxonomy level" name="bloom_level_id" rules={[{ required: true }]}>
                <Select {...bloomlevelSelectProps} />
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(request) === '{}' || request?.difficulty_level_id === '' || request?.difficulty_level_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id" rules={[{ required: true }]}>
                <Select {...difficultylevelSelectProps} />
              </Form.Item>
            </Col>
          ) : null}

          {request?.variant_options !== '' && request?.variant_options !== null ? (
            <Col xs={24} lg={16}>
              <Form.Item label="Variant Of" name="parent_question_id" rules={[{ required: true }]}>
                <Select>
                  {variantList.map((item: any) => (
                    <option key={item.question_id} value={item.id} label={item?.title}>
                      {/* {item.title} */}
                      <RichTextRender
                        key={item?.id}
                        prefixContent={`#${item?.question_id}-`}
                        content={item?.title}
                        styles={{ width: '120px', height: '50px' }}
                      />
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {/* --------Competency and related details----- */}
          {JSON.stringify(request) === '{}' || request?.competency_id === '' || request?.competency_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Competency" name="competency_id" rules={[{ required: true }]}>
                <Select allowClear onChange={handleCompetencyChange} {...competencySelectProps} />
              </Form.Item>
            </Col>
          ) : null}

          {JSON.stringify(request) === '{}' || request?.taxonomy_id === '' || request?.taxonomy_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Taxonomy" name="tn_taxonomy_id" rules={[{ required: true }]}>
                <Select
                  allowClear
                  disabled={
                    !request?.competency_id &&
                    (formProps?.form?.getFieldValue('competency_id') == null || formProps?.form?.getFieldValue('competency_id') == undefined)
                      ? true
                      : false
                  }
                  key={formProps?.form?.getFieldValue('competency_id') || 'no-competency'}
                  loading={tnTaxonomyResults.isFetching}
                  onChange={handleTaxonomyChange}
                  {...tntaxonomySelectProps}
                />
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(request) === '{}' || request?.strand_id === '' || request?.strand_id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Standard" name="strand_id" rules={[{ required: true }]}>
                <Select
                  key={formProps?.form?.getFieldValue('tn_taxonomy_id') || 'no-tn_taxonomy_id'}
                  loading={strandResults.isFetching}
                  allowClear
                  {...strandSelectProps}
                  disabled={
                    !request?.taxonomy_id &&
                    (formProps?.form?.getFieldValue('tn_taxonomy_id') == null || formProps?.form?.getFieldValue('tn_taxonomy_id') == undefined)
                      ? true
                      : false
                  }
                />
              </Form.Item>
            </Col>
          ) : null}
          <Col xs={24} lg={8}>
            <Form.Item label="Custom tag" name="custom_tag" rules={[{ required: false }]}>
              <Select mode="tags" maxLength={1} options={customTags} onChange={handleChangeCustomTag} allowClear />
              {/* <Input type="text" allowClear /> */}
            </Form.Item>
            {!isOpenCustomTag && <p style={{ color: 'red' }}>Can't select multiple custom tags</p>}
          </Col>
          {/* language */}
          <Col xs={24} lg={8}>
            <Form.Item initialValue={'english'} label="Language" name="language" rules={[{ required: true }]}>
              <LanguageSelect />
            </Form.Item>
          </Col>
          {/* variant of*/}
          <Col xs={24} lg={8}>
            <Form.Item label="Variant Of (Question ID)" name="variant_of" rules={[{ required: false }]}>
              <Input type="number" allowClear />
            </Form.Item>
          </Col>
          {/* transilation of */}
          <Col xs={24} lg={8}>
            <Form.Item label="Translated From (Question ID)" name="transilation_of" rules={[{ required: false }]}>
              <Input type="number" allowClear />
            </Form.Item>
          </Col>
          <Form.Item name="created_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="user_type" initialValue={userRole}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
        {/* ------------- */}
        {userAiPermission ? (
          <>
            <Col xs={24} lg={24}>
              <Divider orientation="left" orientationMargin="0" className="primary">
                AMS - GPT
              </Divider>
            </Col>
            <Row gutter={[16, 0]}>
              <Col xs={24} lg={8}>
                <Form.Item label="Instructions">
                  <TextArea
                    value={instructionsDetails}
                    onChange={e => setInstructionDetails(e.target.value)}
                    placeholder="Enter instructions for AMS-GPT"
                    style={{ scrollbarWidth: 'none' }}
                  />
                </Form.Item>
              </Col>
              {/* Add Reference Text Field */}
              <Col xs={24} lg={8}>
                <div>
                  <div>
                    {textReference ? (
                      <Form.Item label="Reference Text">
                        <TextArea
                          value={referenceTextDetails}
                          onChange={e => setReferenceTextDetails(e.target.value)}
                          showCount
                          placeholder="Enter reference to AMS-GPT"
                          style={{ scrollbarWidth: 'none' }}
                          maxLength={1000}
                        />
                      </Form.Item>
                    ) : (
                      //  we can pass text to show why? , api end point, state for storing value
                      <ReferenceFileUpload
                        setReferenceTextDetails={setReferenceTextDetails}
                        apiEndPoint={'check-reference-material'}
                        showText={'click or drag your reference material'}
                      />
                    )}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-evenly', gap: '10px', cursor: 'pointer' }}>
                    <div
                      style={{
                        width: '100%',
                        height: textReference ? '3px' : '3px',
                        background: textReference
                          ? 'linear-gradient(to right, #2c78d4, #4facfe)'
                          : 'linear-gradient(264deg, rgba(200,200,200,1) 21%, rgba(208,205,205,1) 30%, rgba(208,208,203,1) 57%)',
                      }}
                      onClick={() => {
                        setReferenceTextDetails('')
                        setTextReference(!textReference)
                      }}
                    />

                    <div
                      style={{
                        width: '100%',
                        height: !textReference ? '3px' : '3px',
                        background: !textReference
                          ? 'linear-gradient(to left, #2c78d4, #4facfe)'
                          : 'linear-gradient(264deg, rgba(254,254,254,1) 21%, rgba(221,221,221,1) 30%, rgba(195,195,190,1) 57%)',
                      }}
                      onClick={() => {
                        setReferenceTextDetails('')
                        setTextReference(!textReference)
                      }}
                    />
                  </div>
                </div>
              </Col>
              {/* Generate Button */}
              <Col xs={24} lg={8} style={{ marginBottom: '2rem' }}>
                <Form.Item>
                  <Button
                    loading={loading}
                    onClick={async () => {
                      setLoading(true)
                      const allValues = formProps?.form?.getFieldsValue([
                        'bloom_level_id',
                        'difficulty_level_id',
                        'grade_ids',
                        'question_type_id',
                        'topic_id',
                      ])
                      const reference = referenceTextDetails
                      const responseData: any = await generateAiQuestions(allValues, request, instructionsDetails, reference, user)
                      if (!responseData.error) {
                        handleQuestionType(questionType)
                        //title setting initial value && changing value in the dom
                        handleEditorTitle(responseData.newOptionDetails.question_title, responseData.newOptionDetails.question_insights)
                        setInitialOptions(responseData.newOptionDetails.option_details)
                        formProps?.form?.setFieldsValue({ option_details: responseData.newOptionDetails.option_details })
                        handleOptionTags('')
                      } else {
                        message.error(responseData.message)
                      }
                      setLoading(false)
                    }}
                    style={{
                      marginLeft: '50px',
                      marginTop: '30px',
                      marginRight: '10px',
                      color: 'white',
                      backgroundColor: '#38D2D2',
                      backgroundImage: 'radial-gradient(100% 100% at 100% 0, #5adaff 0, #5468ff 100%)',
                      boxShadow:
                        'inset -3px -3px 9px rgba(255, 255, 255, 0.25), inset 0px 3px 9px rgba(255, 255, 255, 0.3), inset 0px 1px 1px rgba(255, 255, 255, 0.6), inset 0px -8px 36px rgba(0, 0, 0, 0.3), inset 0px 1px 5px rgba(255, 255, 255, 0.6), 2px 19px 31px rgba(0, 0, 0, 0.2)',
                      borderRadius: '14px',
                      fontWeight: 'bold',
                      fontSize: '12px',
                      border: '0',
                      userSelect: 'none',
                      WebkitUserSelect: 'none',
                      touchAction: 'manipulation',
                      cursor: 'pointer',
                    }}
                  >
                    {!loading && (
                      <img
                        src={aiIcon}
                        width="18px"
                        style={{
                          marginRight: '2px',
                          animation: 'bounce 2s infinite',
                        }}
                      />
                    )}
                    Generate Question
                  </Button>
                  <Button
                    type="primary"
                    shape="circle"
                    style={{
                      backgroundColor: '#38D2D2',
                      backgroundImage: 'radial-gradient(100% 100% at 100% 0, #5adaff 0, #5468ff 100%)',
                      borderColor: 'white',
                    }}
                    icon={textReference ? <CloudUploadOutlined /> : <EditOutlined />}
                    size={'middle'}
                    onClick={() => {
                      setReferenceTextDetails('')
                      setTextReference(!textReference)
                    }}
                  />
                  {!textReference && referenceTextDetails && (
                    <ReferenceDetailsPreview referenceText={referenceTextDetails} setReferenceTextDetails={setReferenceTextDetails} />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </>
        ) : (
          <Divider />
        )}

        {/* ----------- */}
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Form.Item
              label="Question"
              name="title"
              // initialValue={editorRef?.current?.getContent()}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <>
                {/*--------------- TINY_MCE TEXT EDITOR ---------------*/}
                {/* <RichTextEditor
                  id="question_title"
                  formValueSetterFn={(content: string) => {
                    formProps?.form?.setFieldsValue({ title: content })
                  }}
                /> */}
                {/* ------------SUN TEXT EDITOR--------------------- */}
                <SunTextEditor
                  key={initialTitleDetails.title}
                  id="question_title"
                  initialValue={initialTitleDetails.title}
                  formValueSetterFn={(content: string) => {
                    formProps?.form?.setFieldsValue({ title: content })
                  }}
                />
              </>
            </Form.Item>
            {/* <button
              onClick={() => {
                const data = formProps?.form?.getFieldsValue(true)
                // const editorData = editorRef?.current?.editor?.getContent()
                console.log({ data })
              }}
            >
              Log editor content
            </button> */}
          </Col>
          {userRole !== 'qreviewer' && userRole !== 'qapprover' && (
            <Col xs={24} lg={18}>
              <Form.Item label="Question Insight" name={'question_insight'} rules={[{ required: false }]}>
                {/* <TextArea rows={4} placeholder="Question Insight" disabled={userRole === 'qreviewer' || userRole === 'qapprover'} /> */}
                {/*--------------- TINY_MCE TEXT EDITOR ---------------*/}
                {/* <RichTextEditor
                  id="question_insight"
                  formValueSetterFn={(content: string) => {
                    formProps?.form?.setFieldsValue({ question_insight: content })
                  }}
                /> */}
                {/* ------------SUN TEXT EDITOR--------------------- */}
                <SunTextEditor
                  key={initialTitleDetails.insights}
                  id="question_insight"
                  initialValue={initialTitleDetails.insights}
                  formValueSetterFn={(content: string) => {
                    formProps?.form?.setFieldsValue({ question_insight: content })
                  }}
                />
              </Form.Item>
            </Col>
          )}
          {questionType === 'ShortAnswer' && (
            <Col xs={24} lg={24}>
              <Form.Item label="Expected points in the answer" name="description">
                <Input />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              {questionType === 'ShortAnswer' && 'Rubric Details'}
              {questionType === 'MCQ' && 'Option Details'}
              {questionType === 'Match' && 'Label Details'}
              {questionType === 'Fill' && 'Answer Details'}
            </Divider>
          </Col>
          {/* {questionType === ('MCQ' || 'Match') && ( */}
          {/* {questionType === 'MCQ' && (
            // <Col xs={24} lg={12}>
            //   <Form.Item label="Options Type" name="option_type" initialValue={'Text'}>
            //     <Select
            //       onChange={handleOptionType}
            //       options={[
            //         { label: 'Text', value: 'Text' },
            //         { label: 'Image', value: 'Image' },
            //       ]}
            //     />
            //   </Form.Item>
            // </Col>
          )} */}
        </Row>
        <div key={`${initialOptions.length}-mcqcontainer`}>
          {questionType === 'MCQ' && (
            <Form.List
              name="option_details"
              rules={[
                {
                  validator: async (_, option_details) => {
                    if (option_details === undefined || option_details.length < 1) {
                      return Promise.reject(new Error('At least 1 option'))
                    }
                  },
                },
              ]}
            >
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    // <Space key={key} style={{ display: 'flex', marginBottom: 8, width: '100%' }} align="baseline">
                    <Row key={key} gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                      <Col lg={10}>
                        <Form.Item
                          {...restField}
                          label="Option Text"
                          name={[name, 'option_text']}
                          rules={[{ required: true, message: 'Missing Option Value' }]}
                        >
                          {/* <ReactMde
                          selectedTab={selectedOptionTab?.includes('mcq_' + key) ? 'preview' : 'write'}
                          onTabChange={(value: any) => handleOptionTabChange(value, 'mcq_' + key)}
                          maxEditorHeight={85}
                          onChange={value => handleValueChange(value, key)}
                          generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                          toolbarCommands={ReactMdeToolbarCommands}
                          paste={{
                            saveImage: saveOptions,
                          }}
                        /> */}
                          <>
                            {/*--------------- TINY_MCE TEXT EDITOR ---------------*/}
                            {/* <RichTextEditor
                            key={key}
                            id={`${name}, option_text`}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'option_text', index)
                            }}
                          /> */}
                            {/* ------------SUN TEXT EDITOR--------------------- */}
                            <SunTextEditor
                              key={key}
                              id={`${name}, option_text`}
                              initialValue={initialOptions?.[key]?.['option_text'] ?? ''}
                              formValueSetterFn={(content: string) => {
                                handleSetFormList(content, key, 'option_text', index)
                              }}
                            />
                          </>
                        </Form.Item>
                      </Col>

                      <Col lg={9}>
                        <Form.Item {...restField} label="Option Insight" name={[name, 'option_insight']} rules={[{ required: false }]}>
                          {/* <TextArea rows={7} placeholder="Option Insight" /> */}
                          {/*--------------- TINY_MCE TEXT EDITOR ---------------*/}
                          {/* <RichTextEditor
                          key={key}
                          id={`${name}, option_insight`}
                          formValueSetterFn={(content: string) => {
                            handleSetFormList(content, key, 'option_insight', index)
                          }}
                        /> */}
                          {/* ------------SUN TEXT EDITOR--------------------- */}
                          <SunTextEditor
                            key={key}
                            id={`${name}, option_insight`}
                            initialValue={initialOptions?.[key]?.['option_insight'] ?? ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'option_insight', index)
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={3}>
                        <Form.Item
                          {...restField}
                          name={[name, 'option_flag']}
                          rules={[{ required: mcqOptionFlagRule ? true : false, message: 'Missing Option Flag' }]}
                        >
                          <Select
                            placeholder="Option Flag"
                            style={{ width: 150 }}
                            // value={selectedItems}
                            onChange={handleOptionTags}
                            // onDeselect={handleDeselectOptionTags}
                            allowClear
                            options={filteredOptions.map(item => ({
                              value: item,
                              label: item,
                            }))}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={1}>
                        <MinusCircleOutlined
                          onClick={() => {
                            remove(name)
                          }}
                        />
                      </Col>
                    </Row>
                    // </Space>
                  ))}
                  {selectedItems === '' ? <Typography.Text type="danger">Select atleast one Right Answer </Typography.Text> : null}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      Add Option
                    </Button>
                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                </>
              )}
            </Form.List>
          )}
        </div>
        <div key={`${initialOptions.length}-fillOptionDetails`}>
          {questionType === 'Fill' && (
            <Form.List
              name="option_details"
              rules={[
                {
                  validator: async (_, option_details) => {
                    // console.log({ option_details })
                    if (option_details === undefined) {
                      return Promise.reject(new Error('Add at least 1 option'))
                    }
                  },
                },
              ]}
            >
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    // <Space key={key} style={{ display: 'flex', marginBottom: 8, width: '100%' }} align="baseline">
                    <Row key={key} gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                      <Col lg={12}>
                        <Form.Item
                          {...restField}
                          label="Right Answer"
                          name={[name, 'right_answer']}
                          rules={[{ required: true, message: 'Missing Option Answer' }]}
                        >
                          {/* <TextArea rows={4} placeholder="Right Answer" /> */}
                          {/*--------------- TINY_MCE TEXT EDITOR ---------------*/}
                          {/* <RichTextEditor
                          id={`option_details_fill_right_answer${name}`}
                          key={key}
                          formValueSetterFn={content => {
                            handleSetFormList(content, key, 'right_answer', index)
                          }}
                        /> */}

                          {/* ------------SUN TEXT EDITOR--------------------- */}
                          <SunTextEditor
                            id={`option_details_fill_right_answer${name}`}
                            key={key}
                            initialValue={initialOptions?.[key]?.['right_answer'] ?? ''}
                            formValueSetterFn={content => {
                              handleSetFormList(content, key, 'right_answer', index)
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={10}>
                        <Form.Item {...restField} label="Option Insights" name={[name, 'option_insights']} rules={[{ required: false }]}>
                          {/* <TextArea rows={4} placeholder="Option Insight" /> */}
                          {/*--------------- TINY_MCE TEXT EDITOR ---------------*/}
                          {/* <RichTextEditor
                          key={key}
                          id={`${name}, option_insight`}
                          formValueSetterFn={(content: string) => {
                            handleSetFormList(content, key, 'option_insight', index)
                          }}
                        /> */}
                          {/* ------------SUN TEXT EDITOR--------------------- */}
                          <SunTextEditor
                            key={key}
                            id={`${name}, option_insight`}
                            initialValue={initialOptions?.[key]?.['option_insights'] ?? ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'option_insight', index)
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={2}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Col>
                    </Row>
                  ))}

                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      Add Option
                    </Button>
                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                </>
              )}
            </Form.List>
          )}
        </div>
        {questionType === 'Match' && (
          <Form.List
            name="option_details"
            rules={[
              {
                validator: async (_, option_details) => {
                  if (option_details === undefined) {
                    return Promise.reject(new Error('Add at least 1 option'))
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <>
                    <Row gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                      <Col lg={8}>
                        <Form.Item
                          {...restField}
                          label="Left Label"
                          name={[name, 'left_label_text']}
                          rules={[{ required: true, message: 'Missing Section' }]}
                        >
                          {/* <ReactMde
                            selectedTab={selectedOptionTab?.includes('match_left_' + key) ? 'preview' : 'write'}
                            onTabChange={(value: any) => handleOptionTabChange(value, 'match_left_' + key)}
                            maxEditorHeight={75}
                            onChange={value => handleValueChange(value, key)}
                            generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                            toolbarCommands={ReactMdeToolbarCommands}
                            paste={{
                              saveImage: saveOptions,
                            }}
                          /> */}
                          <>
                            {/*--------------- TINY_MCE TEXT EDITOR ---------------*/}
                            {/* <RichTextEditor
                              // handleImageUpload={handleImageUplodFromEditor}
                              key={key}
                              id={`match_option_left_label_${name}`}
                              formValueSetterFn={content => {
                                handleSetFormList(content, key, 'left_label_text', index)
                              }}
                            /> */}
                            {/* ------------SUN TEXT EDITOR--------------------- */}
                            <SunTextEditor
                              key={key}
                              id={`match_option_left_label_${name}`}
                              formValueSetterFn={content => {
                                handleSetFormList(content, key, 'left_label_text', index)
                              }}
                            />
                          </>
                          {/* <Input placeholder="Left Label" type="small" /> */}
                        </Form.Item>
                      </Col>
                      <Col lg={8}>
                        <Form.Item
                          {...restField}
                          label="Right Label"
                          name={[name, 'right_label_text']}
                          rules={[{ required: true, message: 'Missing Section' }]}
                        >
                          {/* <ReactMde
                            selectedTab={selectedOptionTab?.includes('match_right_' + key) ? 'preview' : 'write'}
                            onTabChange={(value: any) => handleOptionTabChange(value, 'match_right_' + key)}
                            maxEditorHeight={75}
                            onChange={value => handleValueChange(value, key)}
                            generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                            toolbarCommands={ReactMdeToolbarCommands}
                            paste={{
                              saveImage: saveOptions,
                            }}
                          /> */}
                          <>
                            {/*--------------- TINY_MCE TEXT EDITOR ---------------*/}
                            {/* <RichTextEditor
                              // handleImageUpload={handleImageUplodFromEditor}
                              key={key}
                              id={`match_option_right_label_${name}`}
                              formValueSetterFn={content => {
                                handleSetFormList(content, key, 'right_label_text', index)
                              }}
                            /> */}
                            {/* ------------SUN TEXT EDITOR--------------------- */}
                            <SunTextEditor
                              key={key}
                              id={`match_option_right_label_${name}`}
                              formValueSetterFn={content => {
                                handleSetFormList(content, key, 'right_label_text', index)
                              }}
                            />
                          </>
                        </Form.Item>
                      </Col>
                      <Col lg={7}>
                        <Form.Item {...restField} label="Option Insight" name={[name, 'option_insight']} rules={[{ required: false }]}>
                          {/* <TextArea rows={5} placeholder="Option Insight" /> */}
                          {/*--------------- TINY_MCE TEXT EDITOR ---------------*/}
                          {/* <RichTextEditor
                            key={key}
                            id={`${name}, option_insight`}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'option_insight', index)
                            }}
                          /> */}
                          {/* ------------SUN TEXT EDITOR--------------------- */}
                          <SunTextEditor
                            key={key}
                            id={`${name}, option_insight`}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'option_insight', index)
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col lg={1}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Col>
                    </Row>
                  </>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Option
                  </Button>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        {questionType === 'ShortAnswer' && (
          <Form.List
            initialValue={[
              {
                component_name: '',
                rating_1: '',
                rating_2: '',
                rating_3: '',
                rating_4: '',
                weightage: '',
              },
              {
                component_name: '',
                rating_1: '',
                rating_2: '',
                rating_3: '',
                rating_4: '',
                weightage: '',
              },
              {
                component_name: '',
                rating_1: '',
                rating_2: '',
                rating_3: '',
                rating_4: '',
                weightage: '',
              },
            ]}
            rules={[
              {
                validator: async (_, option_details) => {
                  if (option_details.length >= 8) {
                    return Promise.reject(new Error('Exceeded maximum rubric field. (Max is 7)'))
                  } else if (option_details === undefined) {
                    return Promise.reject(new Error('Add at least 1 option'))
                  }
                },
              },
            ]}
            name="option_details"
          >
            {(fields, { add, remove }, { errors }) => {
              return (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                      <Form.Item {...restField} name={[name, 'component_name']} rules={[{ required: true, message: 'Missing Section' }]}>
                        <Input placeholder="Component Name" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_1']} rules={[{ required: true, message: 'Missing Rating 1' }]}>
                        <Input placeholder="Rating 1" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_2']} rules={[{ required: true, message: 'Missing Rating 2' }]}>
                        <Input placeholder="Rating 2" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_3']} rules={[{ required: true, message: 'Missing Rating 3' }]}>
                        <Input placeholder="Rating 3" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_4']} rules={[{ required: true, message: 'Missing Rating 4' }]}>
                        <Input placeholder="Rating 4" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'weightage']} rules={[{ required: true, message: 'Missing Weightage' }]}>
                        <Input placeholder="Weightage" type="small" style={{ maxWidth: 150 }} />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      Add Option
                    </Button>
                  </Form.Item>
                  <Form.ErrorList errors={errors} />
                </>
              )
            }}
          </Form.List>
        )}
      </Form>
    </Modal>
  )
}